export const property = {
  createProperty: {
    title: "Crear alojamiento",
    of: "de",
  },
  sections: {
    details: "Detalles del alojamiento",
    presentation: "Presentación",
    rooms: "Habitaciones",
    bookingSettings: "Configuración de la reserva",
    checkinSettings: "Configuración del check-in",
    extras: "Servicios avanzados",
  },

  menu: {
    name: "Nombre",
    location: "Ubicación",
    logo: "Logo del alojamiento",
    capacity: "Capacidad",
    services: "Servicios del alojamiento",
    description: "Descripción",

    roomTypes: "Tipos de habitación",
    roomManagement: "Gestionar habitaciones",

    imagesRooms: "Imágenes de las habitaciones",
    imagesProperty: "Imágenes del alojamiento",

    priceCurrency: "Precio y moneda",
    rates: "Tarifas",
    maintenance: "Mantenimiento del alojamiento",

    scheduling: "Programación",

    sesHospedajes: "SES Hospedajes",

    smartLocks: "Cerraduras inteligentes",
    experiences: "Experiencias y servicios",
    chatbot: "Agente IA ✨",
  },
  firstStep: {
    heading: "¿Cuál es el nombre de tu alojamiento?",
    subheading:
      "Atrae a los huéspedes con un nombre llamativo que destaque lo mejor de tu alojamiento.",
    fieldLabel: "Nombre de tu apartamento/hotel",
    placeholder: "ej.: Playa paraíso",
    internalNameLabel: "Nombre interno",
    internalNamePlaceholder: "Nombre de referencia interno para el alojamiento",
  },
  locationStep: {
    heading: "¿Dónde se encuentra tu alojamiento?",
    subheading:
      "Indica la dirección exacta para ayudar a los huéspedes a ubicar tu alojamiento con facilidad.",
    countryLabel: "País",
    addressLabel: "Dirección completa",
    addressPlaceholder: "ej.: Calle Sierpes, 25, Sevilla",
    cityLabel: "Ciudad",
    cityPlaceholder: "ej.: Sevilla",
    zipLabel: "Código postal",
    zipPlaceholder: "ej.: 41004",
  },

  logoStep: {
    heading: "¿Cuál es el logo de tu alojamiento?",
    description:
      "Agrega el logo de tu alojamiento para que se vea más profesional y fácil de identificar. Formatos permitidos: PNG, JPG, SVG.",
    currentLogoTitle: "Logo actual:",
    currentLogoAlt: "Logo actual",
  },

  roomTypeStep: {
    heading: "Información de la habitación",
    description:
      "Ingresa un nombre para este tipo de habitación, como “Habitación Doble” o “Suite Familiar”. Esto te ayudará a identificarla fácilmente en el calendario y los canales de reserva. Desde tu panel podrás agregar tus otros tipos de habitación",
    basicInfoTitle: "Información básica",
    nameLabel: "Nombre",
    namePlaceholder: "Nombre personalizado",
    occupancyTitle: "Capacidad de la habitación",
    adultsLabel: "Adultos",
    childrenLabel: "Niños",
    infantsLabel: "Bebés",
  },

  hotelRoomsStep: {
    heading: "Asigna las habitaciones físicas de tu alojamiento",
    description:
      "Crea las habitaciones reales que tendrás disponibles para reservas, como “101 - Habitación Doble” o “302 - Suite Familiar”. Esto te permitirá organizarlas fácilmente en el calendario y gestionar su disponibilidad.",
    roomTypeLabel: "Tipo de habitación",
    roomNameLabel: "Nombre de la habitación",
    roomNamePlaceholder: "Nombre personalizado",
    roomCodeLabel: "Número o código de la habitación",
    roomCodePlaceholder: "Opcional",
  },

  capacityStep: {
    heading: "Comparte información esencial sobre tu alojamiento",
    description:
      "Especifica la capacidad de huéspedes, cantidad de habitaciones y baños. Podrás editar esta información más tarde desde los detalles de tu alojamiento.",
    labels: {
      guests: "Huéspedes",
      bedrooms: "Dormitorios",
      bathrooms: "Baños",
    },
  },

  servicesStep: {
    heading: "Explica a los huéspedes lo que tu alojamiento tiene para ofrecer",
    subtitle:
      "Selecciona los servicios disponibles. Puedes agregar otros más tarde desde el CMS.",
    services: {
      oven: "Horno y placa",
      pets_allowed: "Se permiten mascotas",
      wifi: "Internet WiFi",
      essentials: "Esenciales",
      washing_machine: "Lavadora",
      air_conditioning: "Aire acondicionado",
      heating: "Calefacción general",
      parking: "Plaza de aparcamiento",
      children_allowed: "Se permiten niños",
      refrigerator: "Nevera",
    },
  },

  priceStep: {
    heading: "¿Cuál es el precio por noche?",
    subtitle:
      "Indica cuál es el precio por defecto para crear la primera tarifa por noche, además de la moneda asociada a tu alojamiento.",
    labels: {
      pricePerNight: "Tarifa por noche",
      currency: "Moneda",
    },
    placeholders: {
      priceExample: "p. ej.: 100",
    },
    requiredAsterisk: "*",
    locked: "Bloqueado",
    currencyLockedHelp:
      "La moneda se define al crear la propiedad y no puede cambiarse después.",
  },

  descriptionStep: {
    heading: "¿Cómo describirías tu alojamiento?",
    subtitle:
      "Atrae a los huéspedes con una descripción breve de tu propiedad. Aprovecha para destacar los servicios que ofreces y los lugares de interés de la zona.",
    placeholders: {
      example:
        "p. ej., Un loft elegante con vistas urbanas, ideal para trabajar, ir de compras y sumergirse en la vida de la ciudad.",
    },
    inspiration: "¿Necesitas inspiración?",
    buttons: {
      useAI: "Usar IA",
      generating: "Generando...",
    },
    errors: {
      generate: "Error al generar la descripción. Inténtalo nuevamente.",
    },
  },
  navigation: {
    save: "Guardar",
    next: "Siguiente",
  },

  common: {
    success: "Éxito",
    error: "Error",
    cancel: "Cancelar",
    save: "Guardar",
  },

  images: {
    heading: "Imágenes del alojamiento",
    subtitleHotel:
      "Agrega las imágenes de tus habitaciones para poder utilizarlas en tu página de reservas directas vía web.",
    subtitleApt:
      "Agrega las imágenes de tu alojamiento para poder utilizarlas en tu página de reservas directas vía web.",

    loadRoomsError: "No se pudieron cargar las habitaciones",
    uploadSuccess: "Imágenes válidas subidas correctamente",
    uploadErrorGeneric: "Error al subir imágenes",

    deleteConfirmMessage: "¿Estás seguro de que quieres eliminar esta imagen?",
    deleteConfirmHeader: "Confirmación",
    deleteAccept: "Eliminar",
    deleteReject: "Cancelar",
    deleteSuccess: "Imagen eliminada correctamente",
    deleteError: "Error al eliminar imagen",

    setMainSuccess: "Imagen principal actualizada",
    setMainError: "Error al establecer imagen principal",

    invalidFilesTitle: "Archivos no válidos",

    mainBadge: "Principal",
  },

  dropzone: {
    prompt: "Arrastra imágenes aquí o haz clic para seleccionar",
    formatHint: "Formatos: JPEG, PNG, GIF.",
    uploading: "Subiendo imágenes... {progress}%",
    invalidHeader: "Algunos archivos no cumplen los requisitos:",
    reasonType: "tipo no válido",
    reasonSize: "tamaño excedido",
    and: "y",
  },

  checkin: {
    heading: "¿Cuándo se enviarán los links de check-in?",
    subtitle:
      "Programa el envío automático del link de check-in para tus huéspedes.",

    options: {
      same_day: { amount: "Mismo día", text: "del check-in" },
      24: { amount: "24 horas", text: "antes del check-in" },
      48: { amount: "48 horas", text: "antes del check-in" },
      72: { amount: "72 horas", text: "antes del check-in" },
      disabled: { amount: "Deshabilitar", text: "enviaré manualmente" },
    },
    recommended: "Recomendado",

    details: {
      sameDay: "6 AM mismo día",
      previousNight: "6 PM tarde anterior",
      corresponding: "6 PM correspondiente",
    },

    confirm: {
      message:
        "¿Estás seguro de que deseas cambiar la programación del check-in?",
      header: "Confirmar cambio",
      accept: "Cambiar programación",
      reject: "Cancelar",
    },

    toasts: {
      loadError: {
        title: "Error",
        body: "No se pudo cargar la configuración de check-in.",
      },
      saveSuccess: {
        title: "Configuración actualizada",
        body: "Proceso realizado con éxito",
      },
    },

    messages: {
      disabled:
        "El envío automático está deshabilitado. Se deberá enviar manualmente.",
      same_day:
        "Los check-ins se enviarán a las 6 AM del mismo día del check-in",
      exactly24:
        "Los check-ins se enviarán a las 6 PM de la tarde anterior al check-in",
      // {days} se reemplaza con el número de días
      daysBefore:
        "Los check-ins se enviarán a las 6 PM, {days} día{days, plural, one{} other{s}} antes del check-in",
    },
  },

  police: {
    header: "Registrar datos de la autoridad competente",
    toasts: {
      saveSuccess: {
        title: "Proceso realizado correctamente",
        body: "Los datos de las autoridades se guardaron con éxito",
      },
    },
    errors: {
      lessorRequired: {
        title: "Error, campo arrendador",
        body: "El campo código de arrendador es requerido",
      },
      establishmentRequired: {
        title: "Error, campo establecimiento",
        body: "El campo código de establecimiento es requerido",
      },
    },
  },
  identity: {
    title: "Verificación de identidad",
    subtitle:
      "Activa o desactiva la verificación de identidad para tus huéspedes.",
    propertyLabel: "Alojamiento:",
    toggle: {
      title: "Habilitar verificación de identidad",
      hint: "Si está activado, se solicitará verificación de identidad a los huéspedes.",
      on: "ON",
      off: "OFF",
    },
    config: {
      whatTitle: "¿Qué le pides al huésped?",
      whatHint: "Elige las fotos que tendrá que hacer. Al menos una.",
      frontTitle: "Documento por delante",
      frontDesc:
        "La cara con la foto. Es la que se compara con la selfie.",
      backTitle: "Documento por detrás",
      backDesc:
        "El reverso, donde suelen ir el domicilio y la zona de lectura.",
      selfieTitle: "Selfie en el momento",
      selfieDesc: "Una foto de su cara, hecha al instante con la cámara.",
      compareOn: "Se compara la cara del documento con la selfie.",
      compareOff:
        "Solo se guarda la foto: sin documento y selfie no hay caras que comparar.",
      requiredTitle: "Y si las caras no coinciden…",
      noTitle: "Puede continuar",
      noDesc:
        "Termina el check-in igualmente y tú lo ves marcado en el panel.",
      yesTitle: "No puede continuar",
      yesDesc:
        "No podrá terminar el check-in hasta que salga bien. Puede intentarlo las veces que haga falta.",
      lockedHint:
        "Para poder exigirlo hacen falta el documento por delante y la selfie.",
      summaryTitle: "El huésped verá",
      needOne: "Tienes que pedirle al menos una foto.",
      noStorage:
        "En este país no guardamos las fotos de identidad, solo el resultado. Sin comparación facial no quedará ningún registro.",
      serviceDown:
        "Si nuestro servicio de comparación falla, al huésped se le deja continuar y tú lo ves marcado: no se queda en la puerta por una avería nuestra.",
    },
    toasts: {
      updated:
        "Configuración de verificación de identidad actualizada con éxito",
      updateError:
        "Error al actualizar la configuración de verificación de identidad",
    },
  },

  guestReviews: {
    subtitle:
      "Ingresa la URL del sitio de reseñas que quieres configurar para que tus huéspedes dejen sus opiniones, ya sea en Google o en otro sitio de reseñas que uses. Esto ayuda a mejorar la visibilidad y reputación del alojamiento.",
    enableTitle: "Habilitar Valoraciones de huéspedes",
  },

  smartLocks: {
    gateCodeLabel: "Clave de acceso al portón principal",
    gateCodePlaceholder: "Ej: 4321",
    gateCodeHelp:
      "Opcional. Si tu propiedad tiene un portón de entrada, añade su código aquí.",
      gateCodeOptional:"Opcional",
    title: "Cerraduras inteligentes",
    subtitle:
      "Conéctate con cerraduras inteligentes compatibles y olvídate de las llaves físicas. Genera y envía códigos de acceso automáticamente, sin intervención manual y 100% seguros.",
    propertyLabel: "Propiedad",
    compatibleTitle: "Cerraduras Inteligentes Compatibles",
    andManyMore: "y muchas más...",

    enableTitle: "Habilitar Cerradura inteligente",
    enableHelp:
      "Envía el código de acceso a tus huéspedes una vez completado el check-in, justo a la hora de entrada seleccionada.",

    configTitle: "Configuración",
    configSubtitle: "Configura tus preferencias de entrega de claves de acceso",

    deliveryLabel: "Hora de entrega del código de acceso",
    deliveryDesc:
      "Selecciona la hora en que se enviará el código de acceso a tu huésped en el día de su reservación.",
    saveTimeBtn: "Guardar hora",
    saveTimeLoading: "Guardando...",

    accessTypeLabel: "Tipo de clave de acceso",

    static: {
      title: "Clave Estática",
      desc: "Usa el mismo código para todos los huéspedes",
    },
    dynamic: {
      title: "Clave dinámica",
      desc: "Genera códigos únicos por reservación",
      soon: "Próximamente",
    },

    masterCodeLabel: "Código de acceso maestro",
    masterCodePlaceholder: "Ingresa tu código de acceso maestro",
    saveCodeBtn: "Guardar código",
    saveCodeLoading: "Guardando...",

    masterCodeHelp:
      "Este código se enviará automáticamente a los huéspedes a la hora especificada en su día de check-in.",

    dynamicInfo: {
      title: "Códigos de Acceso Dinámicos",
      desc: "Esta función premium generará automáticamente códigos de acceso únicos para cada reservación, proporcionando mayor seguridad y experiencia al huésped. ¡Disponible pronto!",
    },

    support: {
      title: "¿Necesitas ayuda con la integración?",
      desc: "Nos conectamos con todas las principales marcas de cerraduras inteligentes del mercado. Nuestro equipo técnico te ayudará a configurar tu modelo específico.",
      cta: "Contactar Soporte",
    },

    errors: {
      emptyKey: "Por favor ingrese una clave de acceso",
    },

    toasts: {
      updateSuccess: "Configuración de Smart Lock actualizada con éxito",
      updateError: "Error al actualizar la configuración de Smart Lock",
      timeSuccess: "Hora de entrega actualizada con éxito",
      timeError: "Error al actualizar la hora de entrega",
      keySuccess: "Clave de acceso guardada con éxito",
      keyError: "Error al guardar la clave de acceso",
    },
  },

  services: {
    listMovedHelp: "La lista de servicios es una sola para toda tu cuenta: se escribe una vez y se marca en qué anuncios se ofrece.",
    listMovedLink: "Ir a Servicios y experiencias",
    title: "Tienda del check-in",
    subtitle: "Al hacer el check-in, el huésped recibe por WhatsApp un enlace con lo que puede añadir a su estancia.",
    enableTitle: "Habilitar tienda de experiencias y servicios",
    enableHelp:
      "Promociona todas las experiencias y servicios adicionales de tu alojamiento. El huésped recibe un link por WhatsApp al hacer check-in.",
    storeType: {
      title: "Tipo de tienda",
      internal: {
        title: "Tienda interna",
        desc: "Gestiona tus servicios directamente en la plataforma",
      },
      external: {
        title: "Tienda externa",
        desc: "Redirige a los huéspedes a tu tienda externa",
      },
    },
    externalConfig: {
      title: "Configuración de tienda externa",
      guestMessageLabel: "Mensaje para los huéspedes",
      guestMessagePlaceholder: "Ej: Descubre nuestros servicios adicionales...",
      guestMessageHelp:
        "Mensaje que verán los huéspedes después del check-in (máx. 200 caracteres)",
      urlLabel: "URL de tu tienda externa",
      urlPlaceholder: "https://tu-tienda-externa.com",
      urlHelp:
        "URL completa donde los huéspedes pueden reservar experiencias y servicios",
      noteTitle: "Nota:",
      noteText:
        "Los huéspedes recibirán este mensaje después de completar el check-in.",
    },
    addBtn: "Agregar",
    delete: {
      title: "¿Eliminar servicio?",
      text: "Esta acción no se puede deshacer",
      confirm: "Eliminar",
      cancel: "Cancelar",
    },
    toasts: {
      stateUpdated: "Estado de servicio actualizado",
      deleted: "Servicio eliminado con éxito",
      storeUpdated:
        "Configuración de Experiencias y servicios actualizada con éxito",
      storeError:
        "Error al actualizar la configuración de Experiencias y servicios",
      configUpdated: "Configuración de tienda actualizada con éxito",
      configError: "Error al actualizar la configuración de tienda",
    },
  },
  bot: {
    enableTitle: "Habilitar agente IA",
    enableHelp:
      "Automatiza la atención de tus huéspedes con respuestas rápidas por WhatsApp.",
  },

  rooms: {
    heading: "Tipos de habitación",
    subtitle: "Gestiona los tipos de habitación de tu alojamiento.",
    addTypeCta: "Agregar tipo de habitación",
    adultsCapacity: "Capacidad de adultos: {count}",
    emptyList: "No hay habitaciones registradas.",

    deleteConfirmHeader: "Confirmar eliminación",
    deleteConfirmMessage:
      "¿Estás seguro de que deseas eliminar esta habitación? Esta acción no se puede deshacer.",
    deleteConfirmAccept: "Sí, eliminar",
    deleteConfirmReject: "Cancelar",

    deleteSuccess: "Habitación eliminada correctamente.",
    deleteError: "Error al eliminar la habitación.",
  },
  roomMgmt: {
    remaining: "Disponibles: {count}",
    heading: "Gestionar habitaciones",
    subtitle: "Asigna habitaciones individuales a los tipos registrados.",
    totalRooms: "Total habitaciones: {count}",

    typeLabel: "Tipo",
    codeLabel: "Código",
    nameLabel: "Nombre",
    descLabel: "Descripción",

    selectPlaceholder: "Seleccione",
    codePlaceholder: "Código",
    namePlaceholder: "Nombre de la habitación",
    descPlaceholder: "Descripción de la habitación",

    addBtn: "Agregar",

    planLimitTitle: "Límite alcanzado",
    planLimitMsg:
      "Has alcanzado el número máximo de habitaciones permitidas en tu plan. Por favor, actualiza tu suscripción para añadir más.",

    loadTypesError: "No se pudieron cargar los tipos de habitación",
    loadRoomsError: "No se pudieron cargar las habitaciones existentes",

    saveSuccessTitle: "Proceso exitoso",
    saveSuccessMsg: "Habitaciones guardadas correctamente",
    saveError: "No se pudieron guardar las habitaciones",

    deleteSuccess: "Habitación eliminada correctamente.",
    deleteError: "Error al eliminar la habitación.",
    formIncompleteError:
      "Por favor completa el tipo de habitación y el nombre en todas las habitaciones.",
  },

  rates: {
    heading: "Tarifas",
    subtitleHotel: "Gestiona las tarifas de tus alojamientos.",
    subtitleSingle: "Gestiona las tarifas de tu alojamiento.",
    adultsCapacity: "Capacidad de adultos: {count}",
    roomsCount: "Habitaciones {count}",
    singleUnit: "Unidad alojativa",

    table: {
      name: "Nombre",
      occupancy: "Personas",
      priceTaxIncl: "Valor (IMPUESTOS INCLUIDOS)",
      actions: "Acciones",
    },

    addRate: "Agregar tarifa",
    emptyList: "No hay tarifas registradas.",

    deleteConfirmHeader: "Confirmar eliminación",
    deleteConfirmMessage:
      "¿Estás seguro de que deseas eliminar esta Tarifa? Esta acción no se puede deshacer.",
    deleteConfirmAccept: "Sí, eliminar",
    deleteConfirmReject: "Cancelar",

    deleteSuccess: "Tarifa eliminada correctamente.",
    deleteError: "Error al eliminar la Tarifa.",
  },
};

export default property;
